import { AxiosInstance } from 'axios';
import { Socket } from 'socket.io-client';
import { ICache } from './types';
import { Axios } from './utils/axios';

export let store: any,
  version: string,
  socket: Socket,
  axiosApi: Axios,
  axiosWeb: AxiosInstance,
  cache: Partial<ICache>;

export let token: string;

export const setVersion = (value: any) => {
  version = value;
};

export const setStore = (value: any) => {
  store = value;
};

export const setSocket = (value: Socket) => {
  socket = value;
};

export const setAxiosApi = (value: Axios) => {
  axiosApi = value;
};

export const setAxiosWeb = (value: AxiosInstance) => {
  axiosWeb = value;
};

export const setToken = (t: string) => {
  token = t;
};

export const getAccessTokenSilently = () => {
  return Promise.resolve(token);
};

// cache

export const getCache = (key: string) => {
  return (cache as any)[key];
};

export const patchCache = (change: Partial<ICache>) => {
  cache = { ...cache, ...change };
};
